<template>
    <div class="row px-1 h-100">
        <div class="col-12 bg-gray2 text-center">
            <div class="pb-1">
                <img
                    :class="shopSosh ? 'filter-gray3 illustration-height' : 'illustration-height'"
                    :src="dto.imageUrl"
                    alt=""
                >
            </div>
            <div class="pb-2">
                <h4 class="text-gray3 mb-0" style="max-width: inherit">
                    {{ dto.title }}
                </h4>
                <p class="lead text-gray3 mb-0">{{ dto.subtitle }}</p>
            </div>
        </div>
        <div class="row mx-auto justify-content-center">
            <div class="col-12 col-md-6 col-lg-4 p-1">
                <div class="">
                    <a class="ob1-card ob1-card-link card-width bg-white p-1"
                       :href="dto.ctaMobile.actionUrl"
                       :data-oevent-category="dto.ctaMobile.tmsData.category"
                       :data-oevent-action="dto.ctaMobile.tmsData.action"
                       :data-oevent-label="dto.ctaMobile.tmsData.label"
                    >
                        <div>
                            <p class="d-flex align-items-center mb-0">
                                <img
                                    height="66"
                                    :src="dto.ctaMobile.imageUrl"
                                    alt=""
                                >
                                <span class="fw-bold ms-1 ms-md-2">{{ dto.ctaMobile.label }}</span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 p-1">
                <div class="">
                    <a class="ob1-card ob1-card-link card-width bg-white p-1"
                       :href="dto.ctaInternet.actionUrl"
                       :data-oevent-category="dto.ctaInternet.tmsData.category"
                       :data-oevent-action="dto.ctaInternet.tmsData.action"
                       :data-oevent-label="dto.ctaInternet.tmsData.label"
                    >
                        <div>
                            <p class="d-flex align-items-center mb-0">
                                <img
                                    height="66"
                                    :src="dto.ctaInternet.imageUrl"
                                    alt=""
                                >
                                <span class="fw-bold ms-1 ms-md-2">{{ dto.ctaInternet.label }}</span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 p-1">
                <div class="">
                    <a class="ob1-card ob1-card-link card-width bg-white p-1"
                       :href="dto.ctaTerminal.actionUrl"
                       :data-oevent-category="dto.ctaTerminal.tmsData.category"
                       :data-oevent-action="dto.ctaTerminal.tmsData.action"
                       :data-oevent-label="dto.ctaTerminal.tmsData.label"
                    >
                        <div>
                            <p class="d-flex align-items-center mb-0">
                                <img
                                    height="66"
                                    :src="dto.ctaTerminal.imageUrl"
                                    alt=""
                                >
                                <span class="fw-bold ms-1 ms-md-2">{{ dto.ctaTerminal.label }}</span>
                            </p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CartPageEmptyContent',
  props: {
    dto: {
        type: Object,
        required: true,
    },
    shopSosh: {
        type: Boolean,
        default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import 'ob1_common', 'ob1_variables', 'msh_mixins';

.card-width {
    /*@media (min-width: #{map-get($grid-breakpoints, md)}) {
        width: 360px;
    }*/
}

.filter-gray3 {
    filter: brightness(0) saturate(100%) invert(31%) sepia(0%) saturate(1877%) hue-rotate(231deg) brightness(96%) contrast(83%);
}

.illustration-height {
    height: auto;
    max-width: 100%;
}

</style>
